import { Entitlement } from '@tradingblock/types';

export const entitlementUpdateKey = (userName: string, id: number | string) => `${userName}-${id}`;

export const getEntityKey = (re: Entitlement) => {
  const userId = re.userId;
  const userName = re.userName;

  return entitlementUpdateKey(userName, userId);
};
